import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './NewRequest.css';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../Backdrop/Backdrop';
import requestImg from '../../../assets/images/request-icon.png';
import closeImg from '../../../assets/images/close-icon.png';
import saveImg from '../../../assets/images/save-icon.png';
import Icon from '../Icon/Icon';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import Input from '../Input/Input';
import logError from '../../../store/LogError';
import axios from '../../../axios-trips';
import * as actionTypes from '../../../store/actions';

class NewRequest extends Component {

  createInputConfig = (elementType,
    elementConfig,
    label,
    value = '',
    validation = {},
    valid = true,
    extraClass = null,
    extraAction = null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraClass: extraClass,
      extraAction: extraAction,
      touched: false,
      errorMessage: null,
      loading: false
    });
  }

  getTodayDate() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate());
    let date = tomorrow.getFullYear() + "-";
    if ((tomorrow.getMonth() + 1) < 10) {
      date += "0";
    }
    date += (tomorrow.getMonth() + 1) + "-";
    if (tomorrow.getDate() < 10) {
      date += "0"
    }
    date += tomorrow.getDate();
    return date;
  }

  getManagers() {
    return this.props.managers.map((manager, index) => {
      return (
        { value: manager.name, displayValue: manager.name }
      )
    });
  }

  createManagers() {
    if (this.props.managers.length > 2 && this.state.requestForm.manager.loading) {
      return;
    }

    this.updateLoading("manager", true);
    axios({
      method: 'get',
      url: '/api/v1/managers',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.updateLoading("manager", false);
        const cardForm = { ...this.state.requestForm };
        this.props.onSetManagers(response.data);
      })
      .catch(error => {
        this.updateLoading("manager", false);
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/managers'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Помилка на сервері.", "Danger");
        }
      });
  }

  createLocations() {
    let formattedLocations = [];
    const locations = Object.values(this.props.locations);
    locations.sort(function (a, b) {
      if (a.originatingLocation && !b.originatingLocation) {
        return -1;
      } else if (!a.originatingLocation && b.originatingLocation) {
        return 1;
      } else if (a.region > b.region) {
        return 1;
      } else if (a.region === b.region) {
        return a.locationName > b.locationName ? 1 : -1;
      } else {
        return -1;
      }
    });
    locations.forEach(function (obj) {
      formattedLocations.push({ value: obj.locationName, displayValue: obj.locationName })
    });
    return formattedLocations;
  }

  state = {
    loading: false,
    requestForm: {
      origin: this.createInputConfig(
        'select',
        {
          options: [
            ...this.createLocations()
          ]
        },
        'Звідки: ',
        'Балахна',
        {},
        true,
        classes.InlineInput),
      destination: this.createInputConfig(
        'select',
        {
          options: [
            ...this.createLocations()
          ]
        },
        'Куди: ',
        'Баловка',
        { required: true },
        true,
        classes.InlineInput),
      manager: this.createInputConfig(
        'input-search',
        {
          options: []
        },
        'Менеджер: ',
        null,
        { required: true },
        false,
        null,
        (ev) => this.createManagers(ev)),
      priority: this.createInputConfig(
        'select',
        {
          options: [
            { value: 'П1', displayValue: 'П1' },
            { value: 'П2', displayValue: 'П2' },
            { value: 'П3', displayValue: 'П3' }
          ]
        },
        'Пріоритет: ',
        'П3',
        { required: true },
        true),
      requestType: this.createInputConfig(
        'select',
        {
          options: [
            { value: 'ЗК', displayValue: 'ЗК' },
            { value: 'ЗПМ', displayValue: 'ЗПМ' },
            { value: 'ЗПМ_ЗК', displayValue: 'ЗПМ_ЗК' }
          ]
        },
        'Тип Заявки: ',
        'ЗК',
        { required: true },
        true),
      weight: this.createInputConfig(
        'input',
        { type: 'number', step: "0.01", min: "0.1", placeholder: "0" },
        'Вага (тонн): ',
        0.1,
        { required: true },
        true,
        classes.InlineTriple),
      partialLoad: this.createInputConfig(
        'toggle-switch',
        {},
        'Часткове Завантаження: ',
        false,
        { required: false },
        true,
        classes.InlineTriple),
      initiator: this.createInputConfig(
        'toggle-switch',
        {},
        'Ініціатор: ',
        false,
        { required: false },
        true,
        classes.InlineTriple),
      requestTripDate: this.createInputConfig(
        'input',
        { type: 'date', },
        'Дата: ',
        this.getTodayDate(),
        { required: true, type: 'date' },
        true,
        classes.InlineInput),
      dateFlexibility: this.createInputConfig(
        'select',
        {
          options: [
            { value: '0', displayValue: '0' },
            { value: '1', displayValue: '+1' },
            { value: '2', displayValue: '+2' },
            { value: '3', displayValue: '+3' },
            { value: '4', displayValue: '+4' },
            { value: '5', displayValue: '+5' },
            { value: '6', displayValue: '+6' },
            { value: '7', displayValue: '+7' }
          ]
        },
        'Гнучкість Дати: ',
        '0',
        { required: true },
        true,
        classes.InlineInput),
      unloading: this.createInputConfig(
        'input',
        { type: 'text' },
        'Вивантаження: ',
        '',
        { required: false },
        true)
    },
    formIsValid: false
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.props.closeCard();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  compareDisplayValue = (a, b) => {
    if (a.displayValue > b.displayValue) {
      return 1;
    } else if (a.displayValue < b.displayValue) {
      return -1;
    }
    return 0;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.show && this.props.show && this.props.managers.length <= 2) {
      this.createManagers();
    }

    if (prevProps.managers !== this.props.managers) {
      const updatedRequestForm = { ...this.state.requestForm };
      updatedRequestForm.manager.elementConfig.options = this.getManagers().sort(this.compareDisplayValue);
      this.setState({ requestForm: updatedRequestForm });
    }

    if (prevProps.locations !== this.props.locations) {
      const updatedRequestForm = { ...this.state.requestForm };
      updatedRequestForm.origin.elementConfig.options = [...this.createLocations()];
      updatedRequestForm.destination.elementConfig.options = [...this.createLocations()];
      this.setState({ requestForm: updatedRequestForm });
    }

    if ((prevProps.origin !== this.props.origin ||
      prevProps.destination !== this.props.destination)) {
      if (this.props.origin === undefined || this.props.destination === undefined) {
        const updatedRequestForm = { ...this.state.requestForm };
        updatedRequestForm.origin.value = "Балахна";
        updatedRequestForm.destination.value = "Баловка";
        this.setState({ requestForm: updatedRequestForm });
      } else {
        const updatedRequestForm = { ...this.state.requestForm };
        updatedRequestForm.origin.value = this.props.origin;
        updatedRequestForm.destination.value = this.props.destination;
        this.setState({ requestForm: updatedRequestForm });
      }
    }
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = (value ? (value.trim !== '') : false) && isValid;
    }

    if (rules.type === 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.type === "confirmPassword") {
      isValid = this.state.registerForm.password.value === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && (value ? (value.trim === '') : true)) {
      errorMessage = 'Це поле обов\'язкове';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введіть пошту';
      }
    }

    if (rules.type === "confirmPassword" && this.state.registerForm.password.value !== value) {
      errorMessage = 'Паролі повинні співпадати';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Мінімальна довжина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальна довжина: ' + rules.minLength;
    }

    return errorMessage;
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.requestForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedOrderForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }
    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);
    updatedOrderForm[elementId] = updatedFormElement;
    let capacityFilled = null;

    let formIsValid = true;
    for (let inputIdentifier in updatedOrderForm) {
      formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ requestForm: updatedOrderForm, formIsValid: formIsValid });
  }

  newRequestHandler = (event) => {
    event.preventDefault();
    let date = Date.parse(this.state.requestForm.requestTripDate.value);
    date = new Date(date);
    let dateStr = date.getFullYear() + "-";
    if ((date.getMonth() + 1) < 10) {
      dateStr += "0";
    }
    dateStr += (date.getMonth() + 1) + "-";
    if (date.getDate() < 10) {
      dateStr += "0";
    }
    dateStr += date.getDate();

    console.log("My destination ", this.state.requestForm.destination);
    if (this.props.locations[this.state.requestForm.destination.value].region === 7) {
      this.props.addNotification("Помилка, не можна створити заявку з 'Куди' в Імпорт.", "Danger");
      return;
    }

    const data = {
      tripDate: dateStr,
      origin: {
        ...this.props.locations[this.state.requestForm.origin.value],
      },
      destination: {
        ...this.props.locations[this.state.requestForm.destination.value]
      },
      manager: this.state.requestForm.manager.value,
      priority: this.state.requestForm.priority.value,
      weight: this.state.requestForm.weight.value,
      requestTripDate: dateStr,
      dateFlexibility: this.state.requestForm.dateFlexibility.value,
      requestType: this.state.requestForm.requestType.value,
      partialLoad: this.state.requestForm.partialLoad.value,
      unloading: this.state.requestForm.unloading.value,
      initiator: this.state.requestForm.initiator.value,
      sorting: 0
    }

    axios({
      method: 'post',
      url: '/api/v1/requests?notify=false',
      data: data,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.access_token
      },
    })
      .then(response => {
        console.log(response);
        this.props.addNotification("Заявка була успішно створена.", "Success");
        this.onRequestCreatedHandler(response.data);
        this.props.closeCard();
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/requests?notify=false'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  onRequestCreatedHandler(request) {
    const updatedRequests = [...this.props.requests];
    updatedRequests.push(request);
    this.props.onSetRequests(updatedRequests);
  }

  updateLoading = (attr, loading) => {
    const updatedCarriers = { ...this.state.requestForm };
    updatedCarriers[attr].loading = loading;
    this.setState({ cardForm: updatedCarriers });
  }

  render() {
    let card = null;

    const requestFormArray = [];
    for (let key in this.state.requestForm) {
      requestFormArray.push({ id: key, config: this.state.requestForm[key] });
    }

    card = (
      <Aux>
        <div className={classes.Header}>
          <Icon iconClass={classes.CarIcon} iconSource={requestImg} iconAlt='' className={classes.CardIcon} />
          <p>Нова Заявка</p>

          <button className={classes.CloseButton} onClick={this.props.closeCard}>
            <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
          </button>
          <p style={{ height: "100%" }}></p>
        </div>

        <form className={classes.NewRequestForm} onSubmit={this.newRequestHandler}>
          <div className={classes.Body} >
            {requestFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  loading={formElement.config.loading}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
            })}
          </div>

          <div className={classes.Footer}>
            <ButtonIcon
              btnType='Success'
              iconClass={classes.ButtonIcon}
              iconSource={saveImg}
              disabled={!this.state.formIsValid}
              iconAlt=''>СТВОРИТИ ЗАЯВКУ</ButtonIcon>
          </div>
        </form>
      </Aux>
    );

    let fullScreen = null;
    if (this.props.fullScreen) {
      fullScreen = classes.FullScreen;
    }

    return (
      <Aux>
        <Backdrop show={this.props.show && !this.props.fullScreen} clicked={this.props.closeCard} />
        <div
          className={[classes.CardModal, fullScreen].join(' ')}
          style={{
            transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
            opacity: this.props.show ? '1' : '0'
          }}>
          {card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    carriers: state.carriers,
    managers: state.managers,
    routes: state.routes,
    requests: state.requests,
    origin: state.origin,
    destination: state.destination,
    locations: state.locations,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetRequests: (requests) => dispatch({
      type: actionTypes.REQUESTS,
      requests: requests
    }),
    onSetManagers: (managers) => dispatch({
      type: actionTypes.SET_MANAGERS,
      managers: managers
    }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewRequest);



// WEBPACK FOOTER //
// ./src/components/UI/NewRequest/NewRequest.js